import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import cl from 'classnames';
import {t} from '../../../services/i18nHandler';
import UtilsHelper from '../../../utils/utils-helper';

function TariffsDetailsPeriodsItem({
  period, amount, basePrice, discount, active, onClick, prefix, canAddToCart,
}) {
  const totalDiscount = useMemo(() => {
    if (basePrice) {
      return basePrice - amount;
    }
    return null;
  }, [basePrice, amount]);

  return (
    <div
      className="tariffs_details_periods_item"
      onClick={canAddToCart ? onClick : null}
      role={canAddToCart ? 'button' : null}
    >
      {canAddToCart && (
        <div className="tariffs_details_periods_radio">
          <div className={cl('tariffs_details_periods_radio_item', {
            active,
          })}
          >
            <span />
          </div>
        </div>
      )}
      <div className="tariffs_details_periods_content">
        <div className="row no-gutters">
          <div className="col-sm-5">
            <div className="tariffs_details_periods_period">
              <strong>{period}</strong>
              &nbsp;
              {t('units.month')}
            </div>
            <div className="tariffs_details_periods_price">
              <strong>{UtilsHelper.priceFormat(amount)}</strong>
              &nbsp;
              {t('units.rublesPerMonth')}
            </div>
          </div>
          <div className="col-sm-7">
            {!!discount && (
              <div className="tariffs_details_periods_discount">
                {t('tariffs.discount')}
                {prefix === 1 && (
                  <>
                    &nbsp;
                    {t('tariffs.moreThan')}
                  </>
                )}
                &nbsp;
                {discount}
                %
              </div>
            )}
            {!!totalDiscount && (
              <div className="tariffs_details_periods_total-discount">
                {t('tariffs.totalDiscount')}
                &nbsp;
                <strong>
                  {totalDiscount}
                  &nbsp;
                  {t('units.rublesPerMonth')}
                </strong>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

TariffsDetailsPeriodsItem.defaultProps = {
  onClick: () => {},
  canAddToCart: false,
  active: false,
  period: 0,
  amount: 0,
  basePrice: 0,
  discount: 0,
  prefix: 0,
};

TariffsDetailsPeriodsItem.propTypes = {
  period: PropTypes.number,
  amount: PropTypes.number,
  basePrice: PropTypes.number,
  discount: PropTypes.number,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  prefix: PropTypes.number,
  canAddToCart: PropTypes.bool,
};

export default TariffsDetailsPeriodsItem;
